/*
 * @Author: hwc
 * @Date: 2024-03-15
 * @Description: 格式化类方法集合
 */

import { getOptionsFromDict } from "@/apis/application/dict";

/**
 * @description: 将表格中数据列包含数据字典的列做转化，
 * @param {*} tableData 表格数据
 * @param {*} columns 表格列
 * @return {*}
 */
export function formatTableDataByDict(tableData, columns) {
  const colDictMap = Object.fromEntries(
    columns.map((col) => [col.prop, col.dictCode])
  );
  return (tableData || []).map((row) => {
    Object.keys(row).forEach((col) => {
      colDictMap[col] &&
        (row[col] =
          getOptionsFromDict(colDictMap[col]).find(
            (item) => item.value === row[col]
          )?.label || row[col]);
    });
    return row;
  });
}

/**
 * @description: 将年份转化成标题年份展示函数，
 * @param {*} year 传入年份
 * @return {*} String
 */
export function formatYearTitle(year){
  let nowMonth=new Date().getMonth()+1,nowYear=new Date().getFullYear()
  if(year==nowYear){
    return nowMonth==2?`${year}年1月`:`${year}年1-${nowMonth-1}月`
  }else{
    return `${year}年`
  }
}